module.exports = __webpack_public_path__ + "media/application/images/ui/compare-icon-close-mark2-27a138f4cb1105a8d666e4a6bc3e213a.svg";